import { FC } from 'react';

type Props = {
	className?: string;
};

const NotificationSnoozeIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M12.7397 16.4655C12.8454 16.6953 12.7838 16.9758 12.5756 17.1382C11.8828 17.6789 10.9788 17.9997 9.9997 17.9997C9.02064 17.9997 8.11668 17.6789 7.4238 17.1382C7.21569 16.9758 7.15405 16.6953 7.25971 16.4655C7.29323 16.3925 7.37528 16.3619 7.45478 16.3727C7.85821 16.428 9.13033 16.5923 9.9997 16.5923C10.8691 16.5923 12.1413 16.428 12.5447 16.3727C12.6242 16.3619 12.7062 16.3925 12.7397 16.4655Z'
				fill='inherit'
			/>
			<path
				d='M11.2676 2.13253C11.3828 2.16483 11.4017 2.30448 11.3443 2.40939C11.1989 2.67445 11.1163 2.97874 11.1163 3.30233C11.1163 4.15506 11.69 4.87379 12.4724 5.09364C12.5856 5.12542 12.6397 5.26585 12.5645 5.35611L11.5476 6.57643C11.0854 7.13101 10.9858 7.90287 11.292 8.55661C11.5982 9.21039 12.2549 9.62795 12.9768 9.62795H15.9273C16.0446 9.62795 16.1396 9.72298 16.1396 9.84019C16.1396 10.0466 16.2376 10.2389 16.412 10.4134L17.4645 11.4659C17.5692 11.5705 17.628 11.7125 17.628 11.8605V12.889C17.628 13.3769 17.3533 13.8436 16.8839 14.0548C15.6629 14.6044 13.3667 15.3954 10 15.3954C6.63328 15.3954 4.3371 14.6044 3.11613 14.0548C2.64673 13.8436 2.37207 13.3769 2.37207 12.889V11.8605C2.37207 11.7125 2.43088 11.5705 2.53555 11.4659L3.58799 10.4134C3.76244 10.2389 3.86045 10.0024 3.86045 9.75565V8.13957C3.86045 4.74878 6.60923 2 10 2C10.4198 2 10.8303 2.04221 11.2273 2.12281C11.241 2.12557 11.2544 2.12882 11.2676 2.13253Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.2324 3.3023C12.2324 2.89129 12.5656 2.55811 12.9766 2.55811H16.6976C16.9863 2.55811 17.249 2.72515 17.3715 2.98664C17.494 3.24814 17.4541 3.55688 17.2693 3.77871L14.5655 7.02325H16.6976C17.1086 7.02325 17.4418 7.35644 17.4418 7.76744C17.4418 8.17845 17.1086 8.51163 16.6976 8.51163H12.9766C12.6879 8.51163 12.4252 8.34459 12.3027 8.08309C12.1802 7.82159 12.2201 7.51285 12.4049 7.29102L15.1087 4.04649H12.9766C12.5656 4.04649 12.2324 3.7133 12.2324 3.3023Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default NotificationSnoozeIconSolid;
